export default async (context) => {
    await context.$store.dispatch('main_videos/deleteVideo', {
        index: context.temporaryData.index - 1
    })
    await context.$store.dispatch('main_videos/deleteVideo', {
        index: context.temporaryData.index - 1
    })
    context.close_popup(context)
    context.temporaryData = false
    context.editElementStatus = false
}